export default "__VITE_ASSET__D7hiLWfS__"